const DEFAULT_VETERAN_INFO = {
  rank: '',
  serviceAgency: '',
  serviceType: '',
};

export default DEFAULT_VETERAN_INFO;
